export default "__VITE_ASSET__COSB_BJ3__"